import { getDoc, updateDoc, onSnapshot } from "firebase/firestore";
import { firebaseGetUser } from "../users/usersApi";
import { getUserSavedProducts } from "../products/productsApi";
import { updatePassword } from "firebase/auth";

import {
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
} from "firebase/auth";
import { auth } from "../../firebaseConfig";
import { getDocumentRef } from "../utils";

/**
 * sign in the administrator with email and password
 * @param {string} email
 * @param {string | number} password
 * @returns user | error message
 */
const firebaseSignInAdmin = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );

    if (userCredential) return { data: true };
  } catch (err) {
    console.log(err);
    return {
      error: "Votre email ou mot de passe est invalide, veillez recommencer",
    };
  }
};

/**
 * sibn out the administrator
 */
const firebaseSignOutAdmin = async (id) => {
  try {
    await signOut(auth);

    return { data: true };
  } catch (error) {
    return { error: "And error occured while signing out" };
  }
};

/**
 * signin admin
 * @param {string} id
 * @returns admin with his data
 */
const firebaseGetAdmin = async (id) => {
  //get admin reference
  const adminRef = getDocumentRef("admins", id);
  try {
    //get the document
    const admin = await getDoc(adminRef);
    if (admin.exists()) {
      const adminData = { ...admin.data(), id: admin.id };

      return { data: adminData };
    }

    console.log("admin not found");

    return { data: "user don't exists" };
  } catch (err) {
    console.log(err);
    return { error: "And error occured white geting the admin" };
  }
};

/**
 * Observe the presence of the person(user or admin) on firebase and sigin it at a User or Admin
 * @param {function} globalStateLogin
 */
async function firebaseGetCurrentPerson(globalStateLogin = (data) => {}) {
  try {
    onAuthStateChanged(auth, async (person) => {
      if (!person) return;

      const id = person.uid;

      //get the user or admin
      if (person.email) {
        //it is an admin
        const { data } = await firebaseGetAdmin(id);
        return globalStateLogin(data);
      }

      const { data } = await firebaseGetUser(id);

      const { data: savedProducts } = await getUserSavedProducts(
        data.savedProducts
      );

      globalStateLogin({ ...data, savedProducts });
    });
  } catch (err) {
    console.log(err);
    return { error: "And error occured while getting the current person" };
  }
}

/**
 * Reset the password of the user on firebase
 * @param {String} newPassworld
 * @returns data | error
 */
const resetPassword = async (newPassworld) => {
  //get the current user connected
  const user = auth.currentUser;

  //update the password
  try {
    await updatePassword(user, newPassworld);
    return { data: true };
  } catch (err) {
    console.log(err);
    return { error: "An error occured while resetting the password" };
  }
};

/**
 * update the admin on firebase database
 * @param {string} idAdmin
 * @param {Object} data
 * @returns
 */
const updateAdmin = async (idAdmin, data) => {
  //ref to the admin to update
  const adminRef = getDocumentRef("admins", idAdmin);

  try {
    //update the admin
    await updateDoc(adminRef, { ...data });

    return { data: true };
  } catch (err) {
    console.log(err);
    return { error: "And error occured while updating the admin" };
  }
};

/**
 *
 * @param {*} idAdmin
 * @param {*} globaStateLogin
 * @returns
 */
const getAdminWithUpdatedData = async (
  idAdmin,
  globaStateLogin = (data) => {}
) => {
  //ref to the admin to listen
  const adminRef = getDocumentRef("admins", idAdmin);

  try {
    onSnapshot(adminRef, async (doc) => {
      await firebaseGetCurrentPerson(globaStateLogin);
    });
  } catch (err) {
    console.log(err);
    return { error: "And error occured while getting the updated admin" };
  }
};

export {
  firebaseSignInAdmin,
  firebaseSignOutAdmin,
  firebaseGetCurrentPerson,
  resetPassword,
  updateAdmin,
  getAdminWithUpdatedData,
};
